import { PageViewEventLogger } from '@repo/tracking-service';
import { Title } from '@zenterprise-inc/ui';

import s from '@/components/my/common/layout.module.scss';
import { PolicyPageTopNavigation as TopNavigation, PolicyListItem, TermsItem } from '@/components/my/terms';

const termsData: TermsItem[] = [
  {
    label: '비즈넵 환급 서비스 이용약관',
    link: 'https://bznav.com/popup/terms/bznav-taxrefund-service/',
    clickEvent: 'terms_body_policy'
  },
  {
    label: '개인정보 처리방침',
    link: 'https://bznav.com/popup/terms/privacy/',
    clickEvent: 'terms_body_privacy'
  }
];

export default function TermsPage() {
  return (
    <PageViewEventLogger pageName={'terms'}>
      <TopNavigation />
      <main className={s.main_content}>
        <section className={'px-4.5'}>
          <Title.Headline title={'약관 및 정책'} size={'large'} />
          <ul className={'mt-2'}>
            {termsData.map((item) => (
              <PolicyListItem key={item.label} label={item.label} link={item.link} clickEvent={item.clickEvent} />
            ))}
          </ul>
        </section>
      </main>
    </PageViewEventLogger>
  );
}
